<template>
    <div class="render-post render-post-google" :class="scrollbarClass" :style="{ fontSize: fontSize + 'px' }" ref="render-post">

        <div class="post-content">
            <div class="post-header">
                <div class="img-pages">

                    <template v-for="(page, index) in visiblePages" >
                        <Tooltip
                            :key="index"
                            :active="page.iconEdited"
                            :text="'Voir les modifications apportées'"
                            position="right"
                            :classCustom="`page ${page.iconEdited ? 'iconEdited' : ''}`"
                            @click="() => onClickAvatar(page, index)"
                        >
                            <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'" alt="">
                        </Tooltip>
                    </template>

                    <ContextMenu
                        v-if="pages.length > 4"
                        :options="hiddenPagesOptions"
                        id="contextMenuHiddenPagesGoogle"
                        v-on:clickOption="(_, pageId) => $emit('featurePage', pageId)"
                    >
                        <div class="page count">
                            <p>+{{ pages.length - 3 }}</p>
                        </div>
                    </ContextMenu>
                </div>

                <div class="info" v-if="featuredPage">
                    <p class="name" @click="openGooglePage(featuredPage)">{{ featuredPage.name }}</p>
                    <p class="google">sur Google</p>
                </div>
              
            </div>
            <div class="card-post">
                <template  v-if="medias.length && medias.find(p => p.type2 == 'image' && p.type !== 'image/gif')" >
                    <div v-for="media in medias.filter(m => m.type2 == 'image' && m.type !== 'image/gif').slice(0,1)" class="post-medias media" :key="media.id">
                        <div class="media">
                            <img :src="media.url" alt="">
                        </div>
                    </div>
                </template>
                
                <div class="snippet" v-else-if="snippet.link">
                    <SnippetNetwork :link="snippet.link"></SnippetNetwork>
                </div>
                <div v-else class="post-empty"></div>

                <div class="content-card-post">
                    <div class="post-text" v-if="text">
                        <p v-html="textTranslateMentionAndHastag"></p>
                    </div>
                
                    <p class="redirection" v-if="snippet.link">
                        <a>En savoir plus  ({{ getHostname(snippet.link) }})</a>
                    </p>
                    <p class="date">{{ datePost ? formatDatePost : 'A l\'instant' }}</p>
                </div>
             
            </div>
          
    
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from './../SnippetNetwork.vue'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
        mixins: [renderPostMixin],
        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip,
            ContextMenu
        },

        props: {
            pages: {
                type: Array,
                default: ()=>[] 
            },

            datePost: {
                default: '' 
            },
            medias: {
                type: Array,
                default:  ()=>[] 
            },
            text : {
                type: String,
                default: ''
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : ""
                })
            },

            mentions: {
                type: Object,
                default: ()=>({})
            }
           
        },

        methods: {
            getHostname(url) {
                return (new URL(url)).hostname.replace("www.", "");
            },

            
            openGooglePage(page) {
                const url = `https://business.google.com/n/${page.network_id.replace('locations/','')}/profile`;
                window.open(url, '_blank');
            },

            onClickAvatar(page, index) {
                const isTop = index === this.visiblePages.length - 1
                if (!isTop) {
                    this.$emit('featurePage', page.id)
                    return
                }
                page.iconEdited ? this.$emit('clickPage', page.id) : this.openGooglePage(page)
            }
        },

        computed: {
            visiblePages() {
                return this.pages.slice(0, this.pages.length == 4 ? 4 : 3)
            },

            featuredPage() {
                return this.visiblePages.length ? this.visiblePages[this.visiblePages.length - 1] : null
            },

            hiddenPagesOptions() {
                return this.pages.slice(this.visiblePages.length).map(page => ({ label: page.name, name: page.id }))
            },

            formatDatePost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },


            textTranslateMentionAndHastag() {
                const MAX_BYTES = 1500
                const chars = Array.from(this.text)
                let byteCount = 0, i = 0
                for (const char of chars) {
                    const cp = char.codePointAt(0)
                    const bytes = cp < 0x80 ? 1 : cp < 0x800 ? 2 : cp < 0x10000 ? 3 : 4
                    if (byteCount + bytes > MAX_BYTES) break
                    byteCount += bytes
                    i++
                }
                const truncated = chars.slice(0, i).join('')
                return truncated.replace(/@(\d{13})/g, (match, id) => {
                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.google ? `<span class="mention">@${mention.mention.google.id || mention.mention.google.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
            }
        },
    }
</script>
